import React from 'react';
import { Toaster } from 'sonner';
import LandingPage from './pages/LandingPage';
import GlowCursor from './components/GlowCursor';
import './App.css';

function App() {
    return (
        <>
            <GlowCursor />
            <LandingPage />
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: '#0A0A0A',
                        border: '1px solid #1F1F1F',
                        color: '#EDEDED',
                        fontFamily: 'JetBrains Mono, monospace',
                        fontSize: '13px',
                    },
                }}
            />
        </>
    );
}

export default App;
